import { useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';

import { save } from './Utils/localStorage';
import { routes } from './Routes';
import { constants } from './Configs/constants';
import { getUserData } from './Redux/Selectors/UserSelectors';
import { setCareer } from './Redux/Actions/CareerActions';
import { setAllUsersData } from './Redux/Actions/AllUsersActions';
import { setAllObjects } from './Redux/Actions/ObjectsActions';
import { rx } from './Redux/Actions';
import { unauthRx, refreshRx } from './Redux/Actions/UserActions/thunk';
import { getUsers } from './API/User';
import { getCareer } from './API/Career';
import { getAllObjects } from './API/Object';

import { MainContainer } from './Components/UI/Containers';
import { Header } from './Components/Header';
import { Footer } from './Components/Footer';

import { scrollOnPush } from './Utils/helpers';
import addSwipeEvent from './Utils/Swiper';

addSwipeEvent(window, document);

const { CONSOLE_PROFILE, MAIN } = constants.urls;

const App = () => {
  const { Auth, user } = useSelector(getUserData);

  const firstLoad = useRef(true);
  const authState = useRef(false);

  const dispatch = useDispatch();

  const history = useHistory();

  history.listen(scrollOnPush);

  useEffect(() => {
    return () => Auth && save('User', JSON.stringify(user));
  }, [Auth, user]);

  const redirectOnAuth = useCallback(() => {
    if (Auth !== authState.current) {
      console.log(firstLoad.current, Auth, history);
      authState.current = Auth;
      history.push(Auth ? CONSOLE_PROFILE : MAIN);
    }
  }, [Auth, history]);

  useEffect(() => {
    if (firstLoad.current) {
      dispatch(rx(refreshRx, user.tokenRefresh));
      dispatch(
        rx(
          unauthRx,
          (disp, data) => disp(setAllUsersData(data.data.users)),
          getUsers,
        ),
      );
      authState.current = Auth;
      dispatch(
        rx(
          unauthRx,
          (disp, data) => {
            disp(setCareer(data.data.careerAll));
          },
          getCareer,
        ),
      );
      dispatch(
        rx(
          unauthRx,
          (disp, data) => {
            disp(setAllObjects(data.data.objects));
            firstLoad.current = false;
          },
          getAllObjects,
        ),
      );
    } else redirectOnAuth();
  }, [dispatch, redirectOnAuth, Auth, user.tokenRefresh]);

  return (
    <>
      <Header auth={Auth} />
      {!firstLoad.current && (
        <MainContainer auth={Auth}>
          <Switch>
            {routes.map(({ path, exact, comp, auth, title, roles }, i) => (
              <Route key={i} exact={exact} path={path}>
                {({ match, ...props }) => {
                  document.title = title;
                  return !Auth && auth ? (
                    <Redirect to={MAIN} />
                  ) : !roles || roles.some(role => role === user.role) ? (
                    comp({
                      title,
                      match,
                      ...props,
                    })
                  ) : (
                    <Redirect to={CONSOLE_PROFILE} />
                  );
                }}
              </Route>
            ))}
            <Redirect to={Auth ? CONSOLE_PROFILE : MAIN} />
          </Switch>
        </MainContainer>
      )}
      <Footer />
    </>
  );
};

export default App;
